// extracted by mini-css-extract-plugin
export default {"root":"IconImage_root__VTMEB"};